module.exports = __webpack_public_path__ + "common/tp-featured4-acfa78983812cf60489e3bbb69cdedbe.svg";